import gql from "graphql-tag";

export default gql`
mutation RefreshHolidayWorker($provinceId: Int!, $holidayId: Int!) {
  refreshHolidayWorker(provinceId: $provinceId, holidayId: $holidayId)
}
`;
